<template>

    <section class="grid grid-cols-12 md:gap-x-10">

        <div class="col-span-12 md:col-span-5 sm-max:order-1">
            <nuxt-img width="673" height="745" format="webp" src="/assets/images/cookie-img.jpg" alt="section image"
                class="object-cover w-full 2xl:max-h-[700px] h-full" loading="lazy"
                sizes="xs:330px sm:440px md:745vw lg:388px xl:494" />
        </div>

        <div class="flex flex-col items-start justify-center md:col-span-7 col-span-12 xl:mr-[calc((100vw_-_1280px)_/_2)] 2xl:pl-20 md:pl-10 pl-4 lg:py-0 py-10">
            <h3 class="mb-4 font-bold h2"> Real Frosted Sugar Cookie Coffee Natural Extracts </h3>

           
                <div class="grid items-center mt-4 gap-y-4">
                    <div class="flex items-center gap-3" v-for="(item, index) in checkItems" :key="index">
                        <div class="sm-max:basis-10">
                            <nuxt-img width="22" height="22" format="webp" :src="item.src" :alt="item.alt" class=""
                                loading="lazy" />
                        </div>
                        <span class="textp">
                            {{ item.text }}
                        </span>
                    </div>
                </div>
            
        </div>

    </section>

</template>

<script setup>

const checkItems = ref([
    {
        src: '/assets/images/check-red.png',
        alt: 'check mark',
        text: 'Derived Only From Their Natural Sources And Ingredients.'
    },
    {
        src: '/assets/images/check-red.png',
        alt: 'check mark',
        text: 'Zero Added Sugar.'
    },
    {
        src: '/assets/images/check-red.png',
        alt: 'check mark',
        text: 'Zero Added Calories.'
    },
    {
        src: '/assets/images/check-red.png',
        alt: 'check mark',
        text: 'We Use Only The Highest Quality Essential Oil Extracts.'
    },
    {
        src: '/assets/images/check-red.png',
        alt: 'check mark',
        text: 'Natural Oil-Based Extracts Versus Artificial/Chemical Extracts'
    }
])

defineBuilderComponent({
    friendlyName: 'ImageTextList',
    ignored: true
})
</script>